// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Fonts/N27-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/Fonts/N27-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/Fonts/N27-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/Fonts/N27-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/Images/noise_login.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/Images/password_noise.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: PP-Nuebit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  @font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  @font-face {
    font-family: N27-Bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  @font-face {
    font-family: N27-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  @font-face {
    font-family: N27-Italic;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  @font-face {
    font-family: N27-Italic-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
  @font-face {
    font-family: N27-Medium;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }
  .login-page-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .nav-bar-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height:4.875rem;
    width:100%;
    background-color: #FFFFFF;
    border-bottom: 1pt solid #9C9C9C;
   
  }
  .page-navigation-container1{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 1.8% 0 1% 4.4%;
    height: 2.62rem;
    width: 92.2%;
  }
  .page-navigation-container2{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 1.3% 3.6% 1% 48.4%;
    height: 3rem;
    width: 92.2%;
  }

  .nav-contributors-button{
    height:2.875rem;
    width: 9.8rem;
  }
  .nav-loginSignup-button{
    height:2.35rem;
    width: 9.5rem;
    margin-top: 0.5rem;
  }

  .nav-button-container{
    display: flex;
    height: 100%;
    width:8rem;
    margin-right: 2.5rem;
  }
  .login-container{
    display: flex;
    flex-direction: row;
    width: 92%;
    padding: 6.1% 4% 5% 4%;
    justify-content: space-between;
    align-items: center;
    height: 30.8rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-repeat: no-repeat;
    background-color: transparent;
    background-size: 100% 98%;
  }
  .left-box-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height:32rem;
    width:39rem;
    /* margin-bottom: 6.3rem; */
  }
  .left-box{
    font-family: PP-Nuebit;
    font-size: 8rem;
    text-align: left;
    /* margin-bottom: 1.5rem; */
  }
  .login-right-box-container{
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   height:108%;
   width:35rem;
   background-color: #FFFFFF;
   border: 1px solid black;
   box-shadow: 10px 10px rgb(83, 83, 83)
  }
  .login-right-box{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height:100%;
    width:92%;
    padding:5.74% 4% 3.5% 4%;
  }
  .login-header-container{
    display: flex;
    justify-content:flex-start;
    align-items: flex-start;
    height:3.4rem;
    width:100%;
  }
  .login-header{
    font-family: N27-Light;
    font-size:1.55rem;
    text-align: left;
  }
  .input-field-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-top: 3.5rem;

  }
 
.input-field {
  background-color: #f5f5f5; 
  border: none; 
  border-bottom: 2px solid black; 
  font-size: 1rem; 
  padding: 9px 20px; 
  outline: none; 
  width: 100%; 
  box-sizing: border-box;
  margin-bottom: 1rem; 
}
.input-field::placeholder {
  color: black; 
  font-family: N27-Italic-Light ; 
}
.input-field:focus {
  border-bottom: 2px solid #555; 
}

.forgot-password-container{
  display: flex;
  justify-content: flex-end;
  width: 100%;
  align-items: flex-start;
}
.forgot-password-text{
  font-family: N27;
  font-size: 1rem;
  color: #151515;
  text-align: right;
  margin: 0;
  cursor: pointer;
}
.forgot-password-text:hover{
  text-decoration: underline;
}

.login-box{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:8.5rem;
  width:100%;
  height:3.5rem;
}
.login-button{
  cursor: pointer;
}
.signup-link-container{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:1.5rem;
  width:20.625rem;
  height:0.875rem
}
.signup-link{
  font-family: N27;
  font-size: 1rem;
  text-align: center;
}
.signup-link a, .signup-link Link {
  color: #514FEF; 
  text-decoration: none; 
}

.signup-link a:hover, .signup-link Link:hover {
  text-decoration: underline; 
  color: #514FEF; 
}
.error-message-username-or-password-mismatched {
  display: flex;
  padding:0rem 0 1rem 1rem;
  border: 1pt solid #FF3B3B;
  background-color: #FFF2F2;
  justify-content: space-between;
  z-index: 10;
  position: fixed;
  margin-top: 3.3rem;
}
.error-container{
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
}
.eror-header-container{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.8rem;
}
.info-icon{
  height:1.25rem;
  width: 1.25rem;
  margin-right: 0.5rem;
}
.error-header{
  font-family:N27-Medium;
  font-size: 1.25rem;
  text-align: left;
  margin: 0;
  color: #F71111;
}
.error-content-container{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-left: 1.8rem;
}
.error-content{
  font-family:N27-Medium;
  font-size: 1.25;
  text-align: left;
  margin: 0;
  color: #3C3C3C;
}
.x-icon-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: pointer;
  margin: 0.5rem 0.5rem;
}
.error-outer-counter{
  display: flex;
}
.x-icon{
  height:0.729rem;
  width:0.729rem;
}


.error-message-user-not-found-in-db {
  display: flex;
  padding:0rem 0 1rem 1rem;
  border: 1pt solid #FF3B3B;
  background-color: #FFF2F2;
  justify-content: space-between;
  z-index: 10;
  position: fixed;
  margin-top: 3.3rem;
}

.input-field.error1 { 
  background-color: #ffe5e5 !important;
  border: 2px solid #FF3B3B; 
  border-bottom: 2px solid #FF3B3B !important;
  font-size: 1rem; 
  padding: 9px 20px; 
  outline: none; 
  width: 100%; 
  box-sizing: border-box;
  margin-bottom: 1rem; 
}
.input-field.error1::placeholder {
  color: black; 
  font-family: N27-Italic-Light ; 
}
.error-content a, .error-content Link {
  color: #514FEF; 
  text-decoration: none;
  font-family: N27-Bold; 
} 
.error-content a:hover, .error-content Link:hover {
  text-decoration: underline;  
}
.login-page-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.reset-password-outer-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}
.reset-password-container{
  display: flex;
  flex-direction: row;
  width: 38rem;
  padding: 6.1% 35% 5% 29%;
  justify-content: space-between;
  align-items: center;
  height: 32rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: 100% 95%;
}

.reset-password-inner-container{
  display: flex;
  flex-direction: column;
  background-color: white;
  justify-content: flex-start;
  align-items: flex-start;
  padding:0 0 2.5rem 2rem;
  border: 1pt solid black;
  box-shadow: 10px 10px rgb(83, 83, 83);
  width:100%;
}

.reset-password-content-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  /* margin-top: 0.25rem; */
  height: 100%;
  width: 100%;
}
.reset-password-content-header-container{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 2rem 2.25rem 0;
  width: 100%;
}
.reset-password-content-header{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 2.5rem;
}
.reset-password-header-text{
  font-family:N27-Medium;
  font-size:2.75rem;
  color: black;
  text-align: center;
  margin: 0;
}
.reset-password-content-description-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 2.5rem;
  margin-right: 2rem;
}
.reset-password-content-description{
  font-family:N27-Light;
  font-size:1.25rem;
  color: black;
  text-align:left;
  margin: 0;
}
.reset-password-content-input-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 8.938rem;
  margin-right: 2rem;
  width:94.3%;
}
.reset-password-button-container{
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width:94.3%;
  height:3.5rem;
  margin-right: 2rem;
  cursor: pointer;
}
.reset-password-xbutton-container{
  /* display: flex;
  justify-content: flex-end;
  align-items: flex-start; */
  border-left: 1pt solid black;
  border-bottom:1pt solid black;
  height:1.2rem;
  width: 1.5rem;
  padding:0.375rem 0.375rem;
}
.reset-password-xbutton{
  height:1.1rem;
  width:1.5rem;
  cursor: pointer;
}
.reset-password-error-container{
  display: flex;
  padding:0rem 0 1rem 1rem;
  border: 1pt solid #FF3B3B;
  background-color: #FFF2F2;
  justify-content: space-between;
  width:32.8rem;
  margin-right: 2rem;
  margin-bottom: 2.313rem;
  position: fixed;
  bottom: 8.5rem;
}
.google-auth-outer-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 45%;
  height: 2rem; 
  border: 0.5pt solid #9c9c9c;
  border-radius: 5px; 
  background-color: white;
  padding: 0.7rem 9rem 0.3rem;
  margin-bottom: 1rem;
}
.google-auth-button{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 97%;
  text-align: center; 
  color: black;
  font-family: N27;
  font-size: 1.25rem; 
  cursor: pointer;
  transition: background-color 0.3s;
}
.google-auth-outer-container:hover {
  background-color: #f5f5f5; 
}
.google-auth-bottom-outer-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 32.375rem;
  margin: 0 0.938rem;

}
.google-auth-bottom-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.google-auth-bottom{
  font-family: N27;
  font-size: 1.25rem;
  color: #7C7C7C;
  text-align: left;
  margin: 0;
}
.auth-vector-container{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 33%;
  width:14.594rem;
  border-bottom: 0.3pt solid #E6E6E6;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/CourseLogin/Login.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4CAAoD;EACtD;EACA;IACE,gBAAgB;IAChB,4CAAiD;EACnD;EACA;IACE,qBAAqB;IACrB,4CAA8C;EAChD;EACA;IACE,sBAAsB;IACtB,4CAA+C;EACjD;EACA;IACE,uBAAuB;IACvB,4CAAuD;EACzD;EACA;IACE,6BAA6B;IAC7B,4CAAqD;EACvD;EACA;IACE,uBAAuB;IACvB,4CAAgD;EAClD;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,gCAAgC;;EAElC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,yDAA+D;IAC/D,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;GACC,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;GACnB,WAAW;GACX,WAAW;GACX,yBAAyB;GACzB,uBAAuB;GACvB;EACD;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,aAAa;IACb,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;;EAEpB;;AAEF;EACE,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yDAAkE;EAClE,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;;4BAE0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;;AAEpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kCAAkC;AACpC","sourcesContent":["@font-face {\n    font-family: PP-Nuebit;\n    src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27;\n    src: url(\"../../../assets/Fonts/N27-Regular.otf\");\n  }\n  @font-face {\n    font-family: N27-Bold;\n    src: url(\"../../../assets/Fonts/N27-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27-Light;\n    src: url(\"../../../assets/Fonts/N27-Light.otf\");\n  }\n  @font-face {\n    font-family: N27-Italic;\n    src: url(\"../../../assets/Fonts/N27-RegularItalic.otf\");\n  }\n  @font-face {\n    font-family: N27-Italic-Light;\n    src: url(\"../../../assets/Fonts/N27-LightItalic.otf\");\n  }\n  @font-face {\n    font-family: N27-Medium;\n    src: url(\"../../../assets/Fonts/N27-Medium.otf\");\n  }\n  .login-page-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .nav-bar-container{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height:4.875rem;\n    width:100%;\n    background-color: #FFFFFF;\n    border-bottom: 1pt solid #9C9C9C;\n   \n  }\n  .page-navigation-container1{\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1.8% 0 1% 4.4%;\n    height: 2.62rem;\n    width: 92.2%;\n  }\n  .page-navigation-container2{\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1.3% 3.6% 1% 48.4%;\n    height: 3rem;\n    width: 92.2%;\n  }\n\n  .nav-contributors-button{\n    height:2.875rem;\n    width: 9.8rem;\n  }\n  .nav-loginSignup-button{\n    height:2.35rem;\n    width: 9.5rem;\n    margin-top: 0.5rem;\n  }\n\n  .nav-button-container{\n    display: flex;\n    height: 100%;\n    width:8rem;\n    margin-right: 2.5rem;\n  }\n  .login-container{\n    display: flex;\n    flex-direction: row;\n    width: 92%;\n    padding: 6.1% 4% 5% 4%;\n    justify-content: space-between;\n    align-items: center;\n    height: 30.8rem;\n    background-image: url('../../../assets/Images/noise_login.png');\n    background-repeat: no-repeat;\n    background-color: transparent;\n    background-size: 100% 98%;\n  }\n  .left-box-container{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height:32rem;\n    width:39rem;\n    /* margin-bottom: 6.3rem; */\n  }\n  .left-box{\n    font-family: PP-Nuebit;\n    font-size: 8rem;\n    text-align: left;\n    /* margin-bottom: 1.5rem; */\n  }\n  .login-right-box-container{\n   display: flex;\n   flex-direction: column;\n   justify-content: center;\n   align-items: center;\n   height:108%;\n   width:35rem;\n   background-color: #FFFFFF;\n   border: 1px solid black;\n   box-shadow: 10px 10px rgb(83, 83, 83)\n  }\n  .login-right-box{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    height:100%;\n    width:92%;\n    padding:5.74% 4% 3.5% 4%;\n  }\n  .login-header-container{\n    display: flex;\n    justify-content:flex-start;\n    align-items: flex-start;\n    height:3.4rem;\n    width:100%;\n  }\n  .login-header{\n    font-family: N27-Light;\n    font-size:1.55rem;\n    text-align: left;\n  }\n  .input-field-container{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    margin-top: 3.5rem;\n\n  }\n \n.input-field {\n  background-color: #f5f5f5; \n  border: none; \n  border-bottom: 2px solid black; \n  font-size: 1rem; \n  padding: 9px 20px; \n  outline: none; \n  width: 100%; \n  box-sizing: border-box;\n  margin-bottom: 1rem; \n}\n.input-field::placeholder {\n  color: black; \n  font-family: N27-Italic-Light ; \n}\n.input-field:focus {\n  border-bottom: 2px solid #555; \n}\n\n.forgot-password-container{\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  align-items: flex-start;\n}\n.forgot-password-text{\n  font-family: N27;\n  font-size: 1rem;\n  color: #151515;\n  text-align: right;\n  margin: 0;\n  cursor: pointer;\n}\n.forgot-password-text:hover{\n  text-decoration: underline;\n}\n\n.login-box{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top:8.5rem;\n  width:100%;\n  height:3.5rem;\n}\n.login-button{\n  cursor: pointer;\n}\n.signup-link-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top:1.5rem;\n  width:20.625rem;\n  height:0.875rem\n}\n.signup-link{\n  font-family: N27;\n  font-size: 1rem;\n  text-align: center;\n}\n.signup-link a, .signup-link Link {\n  color: #514FEF; \n  text-decoration: none; \n}\n\n.signup-link a:hover, .signup-link Link:hover {\n  text-decoration: underline; \n  color: #514FEF; \n}\n.error-message-username-or-password-mismatched {\n  display: flex;\n  padding:0rem 0 1rem 1rem;\n  border: 1pt solid #FF3B3B;\n  background-color: #FFF2F2;\n  justify-content: space-between;\n  z-index: 10;\n  position: fixed;\n  margin-top: 3.3rem;\n}\n.error-container{\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.eror-header-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.8rem;\n}\n.info-icon{\n  height:1.25rem;\n  width: 1.25rem;\n  margin-right: 0.5rem;\n}\n.error-header{\n  font-family:N27-Medium;\n  font-size: 1.25rem;\n  text-align: left;\n  margin: 0;\n  color: #F71111;\n}\n.error-content-container{\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-left: 1.8rem;\n}\n.error-content{\n  font-family:N27-Medium;\n  font-size: 1.25;\n  text-align: left;\n  margin: 0;\n  color: #3C3C3C;\n}\n.x-icon-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  cursor: pointer;\n  margin: 0.5rem 0.5rem;\n}\n.error-outer-counter{\n  display: flex;\n}\n.x-icon{\n  height:0.729rem;\n  width:0.729rem;\n}\n\n\n.error-message-user-not-found-in-db {\n  display: flex;\n  padding:0rem 0 1rem 1rem;\n  border: 1pt solid #FF3B3B;\n  background-color: #FFF2F2;\n  justify-content: space-between;\n  z-index: 10;\n  position: fixed;\n  margin-top: 3.3rem;\n}\n\n.input-field.error1 { \n  background-color: #ffe5e5 !important;\n  border: 2px solid #FF3B3B; \n  border-bottom: 2px solid #FF3B3B !important;\n  font-size: 1rem; \n  padding: 9px 20px; \n  outline: none; \n  width: 100%; \n  box-sizing: border-box;\n  margin-bottom: 1rem; \n}\n.input-field.error1::placeholder {\n  color: black; \n  font-family: N27-Italic-Light ; \n}\n.error-content a, .error-content Link {\n  color: #514FEF; \n  text-decoration: none;\n  font-family: N27-Bold; \n} \n.error-content a:hover, .error-content Link:hover {\n  text-decoration: underline;  \n}\n.login-page-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.reset-password-outer-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n.reset-password-container{\n  display: flex;\n  flex-direction: row;\n  width: 38rem;\n  padding: 6.1% 35% 5% 29%;\n  justify-content: space-between;\n  align-items: center;\n  height: 32rem;\n  background-image: url('../../../assets/Images/password_noise.png');\n  background-repeat: no-repeat;\n  background-color: transparent;\n  background-size: 100% 95%;\n}\n\n.reset-password-inner-container{\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding:0 0 2.5rem 2rem;\n  border: 1pt solid black;\n  box-shadow: 10px 10px rgb(83, 83, 83);\n  width:100%;\n}\n\n.reset-password-content-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  /* margin-top: 0.25rem; */\n  height: 100%;\n  width: 100%;\n}\n.reset-password-content-header-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin: 0 2rem 2.25rem 0;\n  width: 100%;\n}\n.reset-password-content-header{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-top: 2.5rem;\n}\n.reset-password-header-text{\n  font-family:N27-Medium;\n  font-size:2.75rem;\n  color: black;\n  text-align: center;\n  margin: 0;\n}\n.reset-password-content-description-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 2.5rem;\n  margin-right: 2rem;\n}\n.reset-password-content-description{\n  font-family:N27-Light;\n  font-size:1.25rem;\n  color: black;\n  text-align:left;\n  margin: 0;\n}\n.reset-password-content-input-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 8.938rem;\n  margin-right: 2rem;\n  width:94.3%;\n}\n.reset-password-button-container{\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width:94.3%;\n  height:3.5rem;\n  margin-right: 2rem;\n  cursor: pointer;\n}\n.reset-password-xbutton-container{\n  /* display: flex;\n  justify-content: flex-end;\n  align-items: flex-start; */\n  border-left: 1pt solid black;\n  border-bottom:1pt solid black;\n  height:1.2rem;\n  width: 1.5rem;\n  padding:0.375rem 0.375rem;\n}\n.reset-password-xbutton{\n  height:1.1rem;\n  width:1.5rem;\n  cursor: pointer;\n}\n.reset-password-error-container{\n  display: flex;\n  padding:0rem 0 1rem 1rem;\n  border: 1pt solid #FF3B3B;\n  background-color: #FFF2F2;\n  justify-content: space-between;\n  width:32.8rem;\n  margin-right: 2rem;\n  margin-bottom: 2.313rem;\n  position: fixed;\n  bottom: 8.5rem;\n}\n.google-auth-outer-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 45%;\n  height: 2rem; \n  border: 0.5pt solid #9c9c9c;\n  border-radius: 5px; \n  background-color: white;\n  padding: 0.7rem 9rem 0.3rem;\n  margin-bottom: 1rem;\n}\n.google-auth-button{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 97%;\n  text-align: center; \n  color: black;\n  font-family: N27;\n  font-size: 1.25rem; \n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n.google-auth-outer-container:hover {\n  background-color: #f5f5f5; \n}\n.google-auth-bottom-outer-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 32.375rem;\n  margin: 0 0.938rem;\n\n}\n.google-auth-bottom-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.google-auth-bottom{\n  font-family: N27;\n  font-size: 1.25rem;\n  color: #7C7C7C;\n  text-align: left;\n  margin: 0;\n}\n.auth-vector-container{\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  height: 33%;\n  width:14.594rem;\n  border-bottom: 0.3pt solid #E6E6E6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
